<template>
  <svg viewBox="0 0 50 50">
    <circle class="ring" cx="25" cy="25" r="20" />
    <circle class="ball" cx="25" cy="5" r="3.5" />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
svg {
  width: 3.75em;
  animation: 1.5s spin ease infinite;
}

.ring {
  fill: none;
  stroke: var(--color-accent-light);
  stroke-width: 2;
}

.ball {
  fill: var(--color-primary);
  stroke: none;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
